import { Component } from '@angular/core';
@Component({
    selector: 'app-comorbidity-section',
    templateUrl: './comorbidity-section.component.html',
    styleUrls: ['./comorbidity-section.component.css'],
    standalone: false
})
export class ComorbiditySectionComponent {}
